/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import ReactHookSelect from 'react-hook-select';
import CommonPopupWrapperComponent from 'Components/common/commonPopupWrapperComponent';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { ReactComponent as PlusIcon } from 'Assets/svg/plus-icon.svg';
import { ReactComponent as SearchIcon } from 'Assets/svg/open-search.svg';
import { ReactComponent as AdaptLogo } from 'Assets/svg/adapt-logo.svg';
import { ReactComponent as TickIcon } from 'Assets/svg/tick-icon-new.svg';
import { ReactComponent as FieldMappingIcon } from 'Assets/svg/field-mapping.svg';
import { ReactComponent as DropDownIcon } from 'Assets/svg/dropdown-icon.svg';
import Button from 'Components/common/Button';
import fieldMappingState from 'Stores/fieldMapping';
import 'Styles/popup/_picklistMappingPopup.scss';
import { Utils } from 'Utils/utils';
import { DO_NOT_MAP_FIELD } from 'Utils/constants';

const PicklistMappingWrapper = observer(props => {
  const { currentCRMData } = props;
  const { picklistFieldMappingData } = fieldMappingState;
  const { adaptFieldLabel = 'Title' } = picklistFieldMappingData;

  const CRMLogo = currentCRMData?.imgComponent;

  const processSelectedCrmField = (selectedKey, fieldData) => {
    const isDoNotMap = selectedKey === DO_NOT_MAP_FIELD.value;

    fieldMappingState.updateCustomPicklistFieldMappings(
      isDoNotMap,
      selectedKey,
      fieldData,
    );
  };

  const renderDropDownIcon = ({ isDropDownOpen }) => {
    return <DropDownIcon className={isDropDownOpen ? 'open' : ''} />;
  };

  return (
    <>
      <div className="info-msg">
        In order to match the Adapt's value to your CRM's value, Please select
        the corresponding mapping below. <br />
      </div>

      <div className="field-mapping-wrapper no-enrich-pref">
        <div className="field-header">
          <div className="title-wrap adapt">
            <AdaptLogo className="logo" />
            <span>Adapt</span>
          </div>
          <div className="title-wrap crm-wrap">
            {currentCRMData.isSvg ? (
              <CRMLogo className="logo" />
            ) : (
              <img src={CRMLogo} alt={currentCRMData.title} className="logo" />
            )}
            <span>{currentCRMData.title}</span>
          </div>
        </div>
        <div className="field-body">
          {fieldMappingState.picklistFieldMappings?.map(fieldData => {
            const { adaptLabel, crmKey, crmLabel } = fieldData;

            return (
              <div className="field" key={adaptLabel}>
                <div className="field-inner-wrap">
                  <div className="adapt-field">
                    <div>
                      <TickIcon
                        className={`tick-icon${crmKey ? '' : ' not-selected'}`}
                      />
                      {adaptLabel}
                    </div>
                  </div>
                  <div className="crm-field">
                    <div className="crm-field-select-wrapper">
                      <ReactHookSelect
                        renderDropDownIcon={renderDropDownIcon}
                        searchIcon={<SearchIcon className="search-icon" />}
                        enableValuesOutsideOfOptions
                        searchInputProps={{
                          placeholder: 'Search Field',
                        }}
                        value={crmLabel ? [crmLabel] : []}
                        enableSearch
                        dropdownOffset={{ top: 220, bottom: 0 }}
                        showPlaceholderInOptions={false}
                        placeholder="Yet to be mapped"
                        getValue={value => {
                          const selectedKey = value?.[0];
                          processSelectedCrmField(selectedKey, fieldData);
                        }}
                        options={
                          fieldMappingState.availablePicklistCRMFields?.length >
                          0
                            ? [
                                ...fieldMappingState.availablePicklistCRMFields?.map(
                                  data => {
                                    return {
                                      label: data.crmLabel,
                                      value: data.crmKey,
                                    };
                                  },
                                ),
                                ...[DO_NOT_MAP_FIELD],
                              ]
                            : []
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
});

const PickListActionWrapper = observer(props => {
  const { handleCancel = () => {} } = props;
  return (
    <>
      <Button
        className="close-btn"
        id="cancel"
        name="cancel"
        type="button"
        btnText="Cancel"
        loader={false}
        click={() => {
          handleCancel();
        }}
      />
      <Button
        className={`save-btn ${
          fieldMappingState.picklistFieldMappingData?.customMappingOptions
            ?.length > 0
            ? ''
            : ' disable-btn'
        }`}
        id="save"
        name="save"
        type="button"
        btnText="Save"
        loader={false}
        click={() => {
          const isSaveAllowed =
            fieldMappingState.picklistFieldMappingData?.customMappingOptions
              ?.length > 0;
          if (isSaveAllowed) {
            const parentMappingObj = Utils.copyObjectWithoutReference(
              fieldMappingState.picklistFieldMappingData?.parentMappingObj,
            );
            parentMappingObj.options =
              fieldMappingState.picklistFieldMappingData?.customMappingOptions;
            fieldMappingState.updateCustomFieldMappings(parentMappingObj);
            fieldMappingState.setPicklistFieldMappingData(null);
          }
        }}
      />
    </>
  );
});

const PicklistMappingPopup = observer(props => {
  const { picklistFieldMappingData } = fieldMappingState;
  const {
    adaptFieldLabel = 'Title',
    isInitialMapping = false,
    parentMappingObj,
  } = picklistFieldMappingData;

  const closeClick = () => {
    if (isInitialMapping) {
      // Remove picklist selections for new picklist mapping
      const { adaptKey, adaptLabel } = parentMappingObj;
      const updateObj = {
        adaptKey,
        adaptLabel,
        crmLabel: DO_NOT_MAP_FIELD.label,
        crmKey: DO_NOT_MAP_FIELD.value,
      };

      fieldMappingState.updateCustomFieldMappings(updateObj);
    } else {
      // Reset to previous state
      fieldMappingState.updateCustomFieldMappings(parentMappingObj);
    }
    fieldMappingState.setPicklistFieldMappingData(null);
  };

  return (
    <CommonPopupWrapperComponent
      showCloseBtn
      titleText={`Value Mapping - ${adaptFieldLabel}`}
      content={<PicklistMappingWrapper {...props} />}
      actionBtn={<PickListActionWrapper handleCancel={closeClick} />}
      customParentClass="picklist-mapping-popup"
      closeClickCallback={closeClick}
      clickOutsidePopupCallback={closeClick}
    />
  );
});

export default PicklistMappingPopup;
export { PicklistMappingPopup };
